// @flow

import { TYPES } from "app/models/TimelineItem";
import Player from "timelinely-player/TimelinelyPlayer";

import YoutubePlayer from "timelinely-player/players/YoutubePlayer";
import VideoPlayer from "timelinely-player/players/VideoPlayer";

import TimelineItem from "app/components/TimelineItem/TimelineItem";
import AudioTimelineItem from "./components/TimelineItem/AudioTimelineItem/AudioTimelineItem";
import ImageTimelineItem from "app/components/TimelineItem/ImageTimelineItem/ImageTimelineItem";
import MapTimelineItem from "app/components/TimelineItem/MapTimelineItem/MapTimelineItem";
import TextTimelineItem from "app/components/TimelineItem/TextTimelineItem/TextTimelineItem";
import UrlTimelineItem from "app/components/TimelineItem/UrlTimelineItem/UrlTimelineItem";
import VideoTimelineItem from "app/components/TimelineItem/VideoTimelineItem/VideoTimelineItem";
import WizardTimelineItem from "app/components/TimelineItem/WizardTimelineItem/WizardTimelineItem";

import TimelineCard from "app/components/TimelineCard/TimelineCard";
import AudioTimelineCard from "./components/TimelineCard/AudioTimelineCard/AudioTimelineCard";
import ImageTimelineCard from "app/components/TimelineCard/ImageTimelineCard/ImageTimelineCard";
import MapTimelineCard from "app/components/TimelineCard/MapTimelineCard/MapTimelineCard";
import TextTimelineCard from "app/components/TimelineCard/TextTimelineCard/TextTimelineCard";
import UrlTimelineCard from "app/components/TimelineCard/UrlTimelineCard/UrlTimelineCard";
import VideoTimelineCard from "app/components/TimelineCard/VideoTimelineCard/VideoTimelineCard";

import ShareMedia from "app/components/ShareMedia/ShareMedia";
import FacebookShareMedia from "app/components/ShareMedia/FacebookShareMedia/FacebookShareMedia";
import TwitterShareMedia from "app/components/ShareMedia/TwitterShareMedia/TwitterShareMedia";
import EmailShareMedia from "app/components/ShareMedia/EmailShareMedia/EmailShareMedia";

import FilePreview from "app/components/FilePreview/FilePreview";
import AudioFilePreview from "app/components/FilePreview/AudioFilePreview/AudioFilePreview";
import ImageFilePreview from "app/components/FilePreview/ImageFilePreview/ImageFilePreview";
import VideoFilePreview from "app/components/FilePreview/VideoFilePreview/VideoFilePreview";

// Add Players
Player.addPlayer("youtube", YoutubePlayer);
Player.addPlayer("video", VideoPlayer);

// Add Timeline Item Types
TimelineItem.pushType(TYPES.AUDIO, AudioTimelineItem);
TimelineItem.pushType(TYPES.IMAGE, ImageTimelineItem);
TimelineItem.pushType(TYPES.VIDEO, VideoTimelineItem);
TimelineItem.pushType(TYPES.MAP, MapTimelineItem);
TimelineItem.pushType(TYPES.TEXT, TextTimelineItem);
TimelineItem.pushType(TYPES.URL, UrlTimelineItem);
TimelineItem.pushType(TYPES.YOUTUBE, VideoTimelineItem);
TimelineItem.pushType(TYPES.WIZARD, WizardTimelineItem);

// Add Timeline Card Types
TimelineCard.pushType(TYPES.AUDIO, AudioTimelineCard);
TimelineCard.pushType(TYPES.IMAGE, ImageTimelineCard);
TimelineCard.pushType(TYPES.MAP, MapTimelineCard);
TimelineCard.pushType(TYPES.TEXT, TextTimelineCard);
TimelineCard.pushType(TYPES.URL, UrlTimelineCard);
TimelineCard.pushType(TYPES.YOUTUBE, VideoTimelineCard);
TimelineCard.pushType(TYPES.VIDEO, VideoTimelineCard);

ShareMedia.pushType("facebook", FacebookShareMedia);
ShareMedia.pushType("twitter", TwitterShareMedia);
ShareMedia.pushType("email", EmailShareMedia);

// Add file preview types
FilePreview.pushType("image", ImageFilePreview);
FilePreview.pushType("video", VideoFilePreview);
FilePreview.pushType("audio", AudioFilePreview);



// WEBPACK FOOTER //
// ./src/app/App.js